import cx from 'classnames';
import React from 'react';
import moment from 'moment/moment';
import { getStageProgressWidth } from '../utils';

const getStyle = (row, stages) => {
  const stageNumber = row.status.stage || 1;

  return {
    width: getStageProgressWidth(stages, stageNumber),
    backgroundColor: row.isAperiodic || row.isSpontaneous || row.isGrilled ? null : row.statusName.color,
  };
};

export const CompletedProgress = ({ row, stages }) => {
  return (
    <div
      className={cx('queue-table__loading', {
        aperiodic: row.isAperiodic,
        spontaneous: row.isSpontaneous,
        grilled: row.isGrilled,
      })}
      style={getStyle(row, stages)}
    >
      {row.statusName.label}
      {row.readyTime ? ` at ${moment(row.readyTime).format('LT')}` : ''}
    </div>
  );
};
